import React, {useEffect, useState} from "react";
import {ResponsiveBar} from "@nivo/bar";
import {bestTags, worstTags} from "../../services/ProductRepository";
import {getInterpolatedColor, grayPalette, greenPalette, redPalette, subtle_palette} from "../color/Palettes";

const defaultData = {
    data: [
        {
            tag:"Tema 1",
            successRatio:23,
        },
        {
            tag:"Tema 2",
            successRatio:34,
        },
        {
            tag:"Tema 3",
            successRatio:46,
        },
        {
            tag:"Tema 4",
            successRatio:65,
        },
        {
            tag:"Tema 5",
            successRatio:88,
        }
    ],
    keys: ["successRatio"],
    index:"tag"
}


export function TagStatGraph({height, isStrengths}) {
    const [tagGraph, setTagGraph] = useState(defaultData);
    const [color, setColor] = useState(grayPalette);

    useEffect(() => {
        if (isStrengths) {
            bestTags().then(response => {
                if(response.data.length > 0) {
                    setTagGraph(response)
                    setColor(greenPalette)
                }
            })
        } else {
            worstTags().then(response => {
                if(response.data.length > 0) {
                    setTagGraph(response)
                    setColor(redPalette)
                }
            })
        }
    }, [isStrengths]);

    function calculateMaxValue() {
        if(tagGraph.data.length === 0) {
            return 10;
        }

        const maxValue = Math.max(...tagGraph.data.map(item => item.successRatio))
        return Math.min(maxValue * 1.2, 100)
    }

    function calculateLeftMargin() {
        const pixelsPerCharacter = 8;
        if(tagGraph.data.length === 0) {
            return pixelsPerCharacter;
        }
        return Math.max(...tagGraph.data.map(item => {
            return item.tag.length
        })) * pixelsPerCharacter
    }


    const leftMargin = calculateLeftMargin();
    const maxValue = calculateMaxValue();

    return (
        <div style={{minHeight: height, height: height}} className={"w-100"}>
            <ResponsiveBar
                colors={({data}) => getInterpolatedColor(color, data.successRatio, 0, maxValue)}
                colorBy={"id"}
                data={tagGraph.data}
                keys={tagGraph.keys}
                layout={"horizontal"}
                borderRadius={12}
                enableGridX={true}
                enableGridY={false}
                indexBy={tagGraph.index}
                margin={{top: 50, right: 80, bottom: 80, left: leftMargin}}
                padding={0.15}
                animate={true}
                motionConfig={"slow"}
                valueScale={{type: 'linear', min:0, max:maxValue}}
                indexScale={{type: 'band', round: true}}
                axisTop={null}
                axisRight={null}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "Prosent riktige svar",
                    legendPosition: 'middle',
                    legendOffset: 32,
                    truncateTickAt: 0
                }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legendPosition: 'middle',
                    legendOffset: -40,
                    truncateTickAt: 0
                }}
                labelSkipWidth={12}
                labelSkipHeight={12}
                role="application"
            />
        </div>
    );

}